import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from './hooks/useTranslation';
import { RequestHandler } from './app/RequestHandler';

const titleTranslationKey = 'headTitle';
const descriptionTranslationKey = 'headDescription';


export function HeaderOverride(): JSX.Element {
  const t = useTranslation();
  const requestHandler = new RequestHandler();
  const { country } = requestHandler;
  const title = t(titleTranslationKey) === titleTranslationKey ? `Media Resistance | Festo ${country.toUpperCase()}` : `${t(titleTranslationKey)} ${country.toUpperCase()}`;
  const description = t(descriptionTranslationKey) === descriptionTranslationKey ? 'This tool allows you to view and compare the chemical compatibilities between different materials and chemical substances.' : t(titleTranslationKey);
  return (
    <Helmet>
    <title>
      {title}
    </title>
    <meta
      name="description"
      content={description}
    />
  </Helmet>
  );
}